import React, {
    useCallback, useEffect, useContext
} from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { useValidation } from 'gw-portals-validation-react';
import { WizardPage, wizardProps, WizardPageTemplate } from 'gw-portals-wizard-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './WhatPage.metadata.json5';
import styles from './WhatPage.module.scss';

function FNOLCPWhatPage(props) {
    const translator = useContext(TranslatorContext);
    const {
        wizardData: claimVM,
        updateWizardData,
        history: { location: { state = {} } }
    } = props;
    const {
        onValidate, isComponentValid, initialValidation, registerInitialComponentValidation
    } = useValidation('FNOLCPWhatPage');

    const overrideProps = {
        '@field': {
            showOptional: true
        }
    };
    const resolvers = {
        resolveClassNameMap: styles
    };
    const { claimStatus } = state;

    const validateClaimStatus = useCallback(() => {
        return !_.isEmpty(claimStatus) && claimStatus === translator({ id: 'typekey.ClaimState.draft', defaultMessage: 'Draft' });
    }, [claimStatus, translator]);

    useEffect(() => {
        registerInitialComponentValidation(validateClaimStatus);
    }, [validateClaimStatus, registerInitialComponentValidation]);

    return (
        <WizardPage
            disableNext={!isComponentValid}
            skipWhen={initialValidation}
            template={WizardPageTemplate}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

FNOLCPWhatPage.propTypes = wizardProps;
export default withRouter(FNOLCPWhatPage);
